<template>
  <section>
    <!-- Прелоадер -->
    <transition name="fade">
      <section style="position: absolute; width: 100%;">
        <v-container v-if="preloader">
          <div class="text-center">
            <v-progress-circular indeterminate></v-progress-circular>
          </div>
        </v-container>
      </section>
    </transition>

    <transition name="fade">
      <v-row v-if="!preloader" class="row interviewD">

        <!-- Подтвердить оценку -->
        <div v-if="confirmForm" class="popup-block">
          <div class="form-popup-default">
            <v-card>
              <v-btn class="close-button"
                title="Отменить"
                variant="text"
                text
                @click="closeForm"
              >
                <v-icon>ti-close</v-icon>
              </v-btn>
              <div>
                <v-card-title>Подтвердите действие</v-card-title>
                <v-card-text>
                  <v-form>
                    <v-container>
                      <v-row>
                        <label class="pd-lr-10 mb-4 pr-7 pl-7 text-center">
                          При оценке данного уровня компетенций, для всех дочерних элементов будет проставлена выбранная оценка.
                        </label>

                        <div class="text-center">
                          <v-btn class="btnSave primary-btn mr-4" @click="addMark(currentParentElem, true)">
                            Оценить
                          </v-btn>
                          <v-btn class="btnSave btnClose" color="default" @click="closeForm">
                            Отмена
                          </v-btn>
                        </div>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>
              </div>
            </v-card>
          </div>
        </div>

        <!-- Заголовок с кнопкой -->
        <div class="flexBlock mt-0 mb-3" style="align-items: center;">
          <h3 class="header-title" style="margin: 0;">{{ interview.title }}</h3>

          <div class="group-btn mt-2 custom-flex-btns">
            <div v-if="showActions">
              <div class="group-btn status-btns custom-flex-btns">
                <div v-for="btn in actionBtns" :key="btn.title">
                  <v-btn
                    class="customGlobalBtn primary-btn"
                    variant="text"
                    text
                    @click="updateInterview(btn.action)"
                    :disabled="loadstatusInterview"
                  >
                    <v-progress-circular v-if="showLoader(btn.action)" indeterminate></v-progress-circular>
                    <span v-else>{{ btn.name }}</span>
                  </v-btn>
                </div>
              </div>
            </div>

            <v-btn class="customGlobalBtn emptyBtn" variant="text" text @click="goBack">
              Назад
            </v-btn>
          </div>
        </div>

        <!-- Левая колонка -->
        <div class="col-12 col-md-5 top-interview">
          <div class="col-12 pt-0 pb-0 pr-0 pl-0">
            <div class="col-12 pt-0 pb-5 pr-0 pl-0">
              <div class="interview-card-custom detail-card">
                <span class="interview-status" :class="getStyleStatus(interview.status)">
                  {{ getStatus(interview.status) }}
                </span>

                <div class="container-block">
                  <div class="flex" style="align-items: center;">
                    <div class="h-v-center">
                      <div class="img-container">
                        <div
                          v-if="userAvatar"
                          class="custom-bg-img"
                          :style="getStyleAvatar(data.avatar)"
                        ></div>
                        <img v-else src="@/assets/img/no-foto.png">
                      </div>
                    </div>

                    <div class="container-interview-title">
                      <span class="title-interview p-link" @click="goToProfile(data.id)">
                        {{ safeStr(data.name) }} {{ safeStr(data.lastName) }} {{ safeStr(data.secondName) }}
                      </span>
                      <p>Кандидат</p>
                    </div>
                  </div>

                  <p style="padding: 20px 5px 0; margin-bottom: 0;">
                    Время начала интервью:
                    <b>{{ formatDate(interview.dateTime) }}</b>
                  </p>

                  <p style="padding: 10px 5px 0; margin-bottom: 0;">
                    Тип интервью:
                    <b>{{ getType(interview) }}</b>
                  </p>

                  <hr>

                  <div class="card-info">
                    <h5>
                      E-mail<br />
                      <small v-if="hasValue(data.email)">{{ data.email }}</small>
                      <small v-else>нет</small>
                    </h5>
                    <h5>
                      Telegram<br />
                      <small v-if="hasValue(data.telegram)">
                        <a :href="'https://t.me/' + data.telegram" target="_blank">@{{ data.telegram }}</a>
                      </small>
                      <small v-else>нет</small>
                    </h5>
                    <h5>
                      Телефон<br />
                      <small v-if="hasValue(data.phone)">{{ data.phone }}</small>
                      <small v-else>нет</small>
                    </h5>
                    <h5>
                      Мобильный<br />
                      <small v-if="hasValue(data.mobile)">{{ data.mobile }}</small>
                      <small v-else>нет</small>
                    </h5>
                  </div>
                </div>

                <v-expansion-panels multiple class="custom-list">
                  <v-expansion-panel v-if="data.heads && data.heads.length">
                    <v-expansion-panel-header>Руководители</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <user-card class="user-card">
                        <template v-slot:body>
                          <v-list>
                            <v-list-item v-for="item in data.heads" :key="item.id">
                              <v-list-item-content>
                                <v-list-item-title 
                                  class="action-link"
                                  v-text="safeStr(item.name) + ' ' + safeStr(item.lastName)"
                                  @click="goToProfile(item.id)"
                                ></v-list-item-title>
                              </v-list-item-content>

                              <v-list-item-avatar>
                                <div
                                  v-if="hasValue(item.avatar)"
                                  class="custom-bg-img"
                                  :style="getStyleAvatar(item.avatar)"
                                ></div>
                                <img v-else src="@/assets/img/no-foto.png">
                              </v-list-item-avatar>
                            </v-list-item>
                          </v-list>
                        </template>
                      </user-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel v-if="data.subordinates && data.subordinates.length">
                    <v-expansion-panel-header>Подчиненные</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <user-card class="user-card">
                        <template v-slot:body>
                          <v-list>
                            <v-list-item v-for="item in data.subordinates" :key="item.id">
                              <v-list-item-content>
                                <v-list-item-title v-text="safeStr(item.name) + ' ' + safeStr(item.lastName)"></v-list-item-title>
                              </v-list-item-content>

                              <v-list-item-avatar>
                                <div
                                  v-if="hasValue(item.avatar)"
                                  class="custom-bg-img"
                                  :style="getStyleAvatar(item.avatar)"
                                ></div>
                                <img v-else src="@/assets/img/no-foto.png">
                              </v-list-item-avatar>
                            </v-list-item>
                          </v-list>
                        </template>
                      </user-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel v-if="data.files && data.files.length">
                    <v-expansion-panel-header>Загруженные файлы</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <user-card class="user-card">
                        <template v-slot:body>
                          <section class="container-tab rel">
                              <table>
                                <tr>
                                  <td v-for="file in data.files" :key="file.id" class="custom-i">
                                    <a :href="rootUrl + file.fileLink" target="_blank" :title="file.fileName">
                                      <i :class="fileIcon(file.fileExtension)"></i>
                                      <span>{{ file.fileName }}</span>
                                    </a>
                                  </td>
                                </tr>
                              </table>
                            </section>
                        </template>
                      </user-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header>Ссылка на собеседование</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <user-card class="user-card">
                        <template v-slot:body>

                          <div class="links-view">
                            <div v-if="interview.interviewUrl">
                              <div class="link-view-row">
                                <a 
                                  target="_blank" 
                                  class="interview-link" 
                                  rel="noopener noreferrer"
                                  @click.prevent="copyLink(interview.interviewUrl)"
                                >
                                Скопировать ссылку
                                <v-icon>mdi-content-copy</v-icon>
                              </a>
                              </div>
                            </div>
                            <div v-else class="light-text">Пусто</div>
                          </div>

                        </template>
                      </user-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header>Ссылки на запись</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <user-card class="user-card">
                        <template v-slot:body>

                          <!-- РЕЖИМ РЕДАКТИРОВАНИЯ -->
                          <v-form ref="linksForm" lazy-validation v-if="editLinks" class="links-editor">

                            <div
                              v-for="(link, idx) in linksLocal"
                              :key="'link-' + (link.id || ('new-' + idx))"
                              class="link-row"
                            >
                              <a 
                                v-if="link.id"
                                :href="link.url" 
                                target="_blank" 
                                class="interview-link" 
                                rel="noopener noreferrer"
                              >
                                {{ link.url }}
                              </a>
                              <v-text-field
                                v-else
                                type="url" 
                                :rules="urlRules"
                                v-model="linksLocal[idx].url"
                                dense
                              />

                              <!-- удалить -->
                              <div
                                v-if="linksLocal.length > 0"
                                class="action-link del-link"
                                @click="removeLinkField(idx)"
                                title="Удалить"
                              >
                                <v-icon>mdi-close</v-icon>
                              </div>

                              <div
                                v-if="idx === linksLocal.length - 1 && linksLocal.length < 10"
                                class="action-link add-link"
                                @click="addLinkField"
                                title="Добавить"
                              >
                                <v-icon>mdi-plus</v-icon>
                              </div>
                            </div>

                            <div class="links-hint">
                              {{ linksLocal.length }}/10
                            </div>

                            <div class="links-actions" v-if="isLinksDirty">
                              <div class="text-center">
                                <v-btn 
                                  class="btnSave primary-btn" 
                                  :disabled="linksSaving"
                                  @click="saveLinks"
                                >
                                  Сохранить
                                </v-btn>
                              </div>
                            </div>

                          </v-form>

                          <!-- РЕЖИМ ПРОСМОТРА -->
                          <div v-else class="links-view">
                            <div v-if="linksView.length">
                              <div v-for="(item, idx) in linksView" :key="'view-' + (item.id || idx)" class="link-view-row">
                                <a :href="item.url" target="_blank" class="interview-link" rel="noopener noreferrer">{{ item.url }}</a>
                              </div>
                            </div>
                            <div v-else class="light-text">Пусто</div>
                          </div>

                        </template>
                      </user-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel v-if="interview.status_history && interview.status_history.length" class="history-status">
                    <v-expansion-panel-header>История статусов</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <user-card class="user-card">
                        <template v-slot:body>

                          <v-list>
                                
                            <v-list-item v-for="item in interview.status_history" :key="item.id">
                              <v-list-item-content>
                                <div class="user-card_flex-block">
                                  <div class="user-card_interview_title bold">{{ formatDateChange(item.changed_at) }}</div>
                                  <div class="user-card_interview_title">
                                    {{ item.changed_by.name }} {{ item.changed_by.lastName }}
                                  </div>
                                  
                                </div>
                                <div class="user-card_flex-block user-card_interview_status-list">
                                  <span class="user-card_interview_status">{{ getStatus(item.old_status) }}</span>
                                  <v-icon>mdi-arrow-right</v-icon>
                                  <span class="user-card_interview_status">{{ getStatus(item.new_status) }}</span>
                                </div>
                              </v-list-item-content>
                            </v-list-item>

                          </v-list>

                        </template>
                      </user-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                </v-expansion-panels>
              </div>
            </div>

            <div ref="taskAnchor" style="height: 0;"></div>

            <div
              ref="taskBlock"
              class="block-task-question"
              :class="{ 'task-fixed': taskSticky.isFixed }"
              :style="taskSticky.style"
            >
              
              <div class="block-task-question__title-btns">
                <button
                  v-show="questions.length > 0"
                  type="button"
                  class="block-task-question__tab"
                  :class="{ active: leftTab === 'questions' }"
                  @click="setLeftTab('questions')"
                >
                  Вопросы
                  <span class="block-task-question__count">{{ questions.length }}</span>
                </button>

                <button
                  v-show="tasks.length > 0"
                  type="button"
                  class="block-task-question__tab"
                  :class="{ active: leftTab === 'tasks' }"
                  @click="setLeftTab('tasks')"
                >
                  Задания
                  <span class="block-task-question__count">{{ tasks.length }}</span>
                </button>
              </div>

              <!-- Вопросы -->
              <div v-show="leftTab === 'questions' && questions.length > 0" class="col-12 custom-acc pt-0 pb-5 pr-0 pl-0">
                <div class="block-task-question__container">
                  <div class="task-interview-container mt-2" v-for="item in questions" :key="item.id">
                    <div class="markCard markCardTask">
                      <v-card class="card" outlined>
                        <v-list-item class="mb-0 custom-content-list">
                          <v-list-item-content>
                            <div class="custom-flex" style="align-items: flex-start; width: 100%;">
                              <div class="pr-3" style="width: 80%;">
                                <span class="breadcumbs-interview" style="display: block;">
                                  {{ item.breadcrumb }}
                                </span>
                                <v-list-item-title style="white-space: inherit;" class="upp-h3">
                                  {{ item.title }}
                                </v-list-item-title>
                              </div>

                              <div v-if="markFlag && clickMarkElement === item.id">
                                <div class="mark-circle">
                                  <v-progress-circular indeterminate></v-progress-circular>
                                </div>
                              </div>

                              <!-- кружок показываем только если canViewScore -->
                              <div v-else
                                v-show="item.viewerRights && item.viewerRights.canViewScore"
                                class="mark-circle"
                              >
                                <span v-if="item.score == null">0</span>
                                <span v-else>{{ getNumber(item.score) }}</span>
                              </div>
                            </div>

                            <v-list-item class="mt-3 pl-0" v-show="item.description && item.description.length > 0">
                              {{ item.description }}
                            </v-list-item>

                            <div
                              class="w-100 mark-card__answer block text-h8 mb-1 mt-1 pl-0"
                              v-show="item.viewerRights && item.viewerRights.canViewReferenceAnswer && item.answer && item.answer.length > 0"
                            >
                              <label>Эталонный ответ</label>
                              <p>{{ item.answer }}</p>
                            </div>

                          </v-list-item-content>
                        </v-list-item>

                        <v-footer v-show="showMarksFooter(item)" class="mb-0">
                          <marks-list-second-variant
                            :elemType="item.type"
                            :score="item.score"
                            :type="item.tag"
                            v-on:click.native="addMark(item, false, 'questions')"
                            @selectMark="selectMark"
                          />
                        </v-footer>
                      </v-card>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Задания -->
              <div v-show="leftTab === 'tasks' && tasks.length > 0" class="col-12 custom-acc pt-0 pb-5 pr-0 pl-0">
                <div class="block-task-question__container">
                  <div class="task-interview-container mt-2" v-for="item in tasks" :key="item.id">
                    <div class="markCard markCardTask">
                      <v-card class="card" outlined>
                        <v-list-item class="mb-0 custom-content-list">
                          <v-list-item-content>
                            <div class="custom-flex" style="align-items: flex-start; width: 100%;">
                              <div class="pr-3" style="width: 80%;">
                                <span class="breadcumbs-interview" style="display: block;">
                                  {{ item.breadcrumb }}
                                </span>
                                <v-list-item-title style="white-space: inherit;" class="upp-h3">
                                  {{ item.title }}
                                </v-list-item-title>
                              </div>

                              <div v-if="markFlag && clickMarkElement === item.id">
                                <div class="mark-circle">
                                  <v-progress-circular indeterminate></v-progress-circular>
                                </div>
                              </div>

                              <div v-else
                                v-show="item.viewerRights && item.viewerRights.canViewScore"
                                class="mark-circle"
                              >
                                <span v-if="item.score == null">0</span>
                                <span v-else>{{ getNumber(item.score) }}</span>
                              </div>

                            </div>

                            <v-list-item v-show="item.description && item.description.length > 0" class="mb-4 mt-2 pl-0">
                              {{ item.description }}
                            </v-list-item>

                            <div
                              class="w-100 mark-card__answer block text-h8 mb-1 mt-1 pl-0 mb-4"
                              v-show="item.viewerRights && item.viewerRights.canViewReferenceAnswer && item.answer && item.answer.length > 0"
                            >
                              <label>Эталонный ответ</label>
                              <p>{{ item.answer }}</p>
                            </div>

                            <div class="border-div borderNone w-100 mb-3" v-if="conditionFiles(item)">
                              <label>Файлы для задания</label>
                              <section class="container-tab rel">
                                <table>
                                  <tr>
                                    <td v-for="file in conditionFiles(item)" :key="file.id || file.realFileName" class="custom-i">
                                      <a :href="rootUrl + getFileHref(file)" target="_blank" :title="getFileName(file)">
                                        <i :class="fileIcon(getFileExt(file))"></i>
                                        <span>{{ getFileName(file) }}</span>
                                      </a>
                                    </td>
                                  </tr>
                                </table>
                              </section>
                            </div>

                            <!-- Ответ на задание -->
                            <div 
                              class="w-100 mark-card__answer block text-h8 mb-1 mt-1 pl-0 mb-4" 
                              v-if="item.answerText || item.gitUrl"
                            >
                              <p class="text-h6 custom-layout-title mark-card__answer-title">Ответ на задание</p>

                              <div v-if="item.gitUrl">
                                <label>Ссылка на git</label>
                                <v-list-item class="mb-2 mt-0 pl-0">
                                  <a :href="item.gitUrl" target="_blank">{{ item.gitUrl }}</a>
                                </v-list-item>
                              </div>

                              <div v-if="item.answerText">
                                <label>Пояснение</label>
                                <v-list-item class="mb-2 mt-0 pl-0">{{ item.answerText }}</v-list-item>
                              </div>

                              <div v-if="answerFiles(item)" class="border-div borderNone w-100 mb-3">
                                <label>Файлы ответа</label>
                                <section class="container-tab rel">
                                  <table>
                                    <tr>
                                      <td v-for="file in answerFiles(item)" :key="file.id" class="custom-i">
                                        <a :href="rootUrl + getFileHref(file)" target="_blank" :title="getFileName(file)">
                                          <i :class="fileIcon(getFileExt(file))" />
                                          <span>{{ getFileName(file) }}</span>
                                        </a>
                                      </td>
                                    </tr>
                                  </table>
                                </section>
                              </div>
                            </div>

                          </v-list-item-content>
                        </v-list-item>

                        <v-footer v-show="showMarksFooter(item)" class="mb-0">
                          <marks-list-second-variant
                            :elemType="item.type"
                            :score="item.score"
                            :type="item.tag"
                            v-on:click.native="addMark(item, false, 'tasks')"
                            @selectMark="selectMark"
                          />
                        </v-footer>
                      </v-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Правая колонка -->
        <div class="col-12 col-md-7 top-interview">
          <div class="col-12 pt-0 pb-5 pr-0 pl-0 flex">
            <div>
              <h6>Инициатор</h6>
              <div class="top-interview-card">
                <div class="h-v-center">
                  <div class="img-container">
                    <div
                      v-if="interviewOwnerAvatar"
                      class="custom-bg-img"
                      :style="getStyleAvatar(interview.owner.avatar)"
                    ></div>
                    <img v-else src="@/assets/img/no-foto.png">
                  </div>
                </div>
                <p class="p-link" @click="goToProfile(interview.owner.id)">{{ safeStr(interview.owner.name) + ' ' + safeStr(interview.owner.lastName) }}</p>
              </div>
            </div>

            <div v-if="interview.participants && interview.participants.length > 0" style="display: inline-grid" class="ml-6">
              <h6>Участники</h6>
              <div class="container-tab">
                <table>
                  <tr>
                    <td v-for="item in (interview.participants || [])" :key="item.id">
                      <div class="top-interview-card">
                        <div class="h-v-center">
                          <div class="img-container">
                            <div
                              v-if="hasValue(item.avatar)"
                              class="custom-bg-img"
                              :style="getStyleAvatar(item.avatar)"
                            ></div>
                            <img v-else src="@/assets/img/no-foto.png">
                          </div>
                        </div>
                        <p class="p-link" @click="goToProfile(item.id)">{{ safeStr(item.name) + ' ' + safeStr(item.lastName) }}</p>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <!-- кнопка обновления дерева -->
          <div class="d-flex justify-space-between align-center mb-3">
            <h3 style="margin:0;">Компетенции</h3>
            <v-btn small outlined @click="reloadTree" :disabled="treeLoading">
              Обновить дерево
            </v-btn>
          </div>

          <!-- дерево -->
          <section v-show="allSkills.length > 0">
            <section class="sectionSkillInt" v-for="skill in allSkills" :key="'skill-' + skill.tag">
              <!-- Показываем если внутри есть области знаний -->
              <div 
                v-show="skill.areas && skill.areas.length > 0" 
                class="col-12 pt-0 pb-2 pr-0 pl-0 user-custom-skills"
              >
                <div class="user-cards-competentions hard">
                  <div class="group-skills">
                    <div class="container-title">
                      <h3>{{ skill.title }}</h3>
                    </div>

                    <v-expansion-panels multiple>
                      <InterviewTreeNode
                        v-for="area in skill.areas"
                        :key="area.id"
                        :node="area"
                        :activeId="currentCheckCompetency"
                        :markLoadingId="clickMarkElement"
                        :markFlag="markFlag"
                        :status="interview.status"
                        @selectNode="onSelectNode"
                        @requestMark="onRequestMark"
                        @selectMark="selectMark"
                      />
                    </v-expansion-panels>

                  </div>
                </div>
              </div>
            </section>
          </section>
        </div>

        <v-btn
              v-show="showToTopBtn()"
              class="customGlobalBtn emptyBtn squareBtn"
              variant="text"
              text
              title="Наверх"
              @click="goToTop()"
            >
            <v-icon>mdi-arrow-up</v-icon>
          </v-btn>
          
        <!-- Кнопки статуса -->
        <transition name="fade">
          

          <div v-if="showActions" class="col-12">
            <div class="group-btn status-btns" style="justify-content: center;">
              <div v-for="btn in actionBtns" :key="btn.title">
                <v-btn
                  class="customGlobalBtn primary-btn"
                  variant="text"
                  text
                  @click="updateInterview(btn.action)"
                  :disabled="loadstatusInterview"
                >
                  <v-progress-circular v-if="showLoader(btn.action)" indeterminate></v-progress-circular>
                  <span v-else>{{ btn.name }}</span>
                </v-btn>
              </div>
            </div>
          </div>
        </transition>

      </v-row>
    </transition>
  </section>
</template>

<script>
import UserCard from "@/pages/UserProfileTeamplate/UserCard.vue";
import GlobalRequest from "@/plugins/globalRequest";
import MarksListSecondVariant from "@/components/MarksListSecondVariant";
import globalMethods from "@/plugins/globalMethods";
import InterviewTreeNode from "@/pages/InterviewTemplate/InterviewTreeNode.vue";

import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";

export default {
  name: "InterviewDetail",
  components: {
    UserCard,
    MarksListSecondVariant,
    InterviewTreeNode
  },

  inject: ["usersStore"],

  data() {
    return {
      url: "",

      panel: [0],
      panel1: [1],

      confirmForm: false,
      currentParentElem: null,

      preloader: true,
      treeLoading: false,

      loadstatusInterview: false,

      // entities
      interview: { owner: {}, participants: [] },
      data: { heads: [], subordinates: [], files: [] },

      // tree
      allSkills: [],
      currentCheckCompetency: 0,
      currentSelectedNode: null, // normalized node

      // left lists
      tasks: [],
      questions: [],

      // mark
      mark: 0,
      markFlag: false,
      clickMarkElement: 0,

      // roles
      roles: [],
      isAdmin: false,

      type: ["", "info", "success", "warning", "danger"],

      taskSticky: {
        isFixed: false,
        style: {}
      },
      leftTab: 'questions',
      currentUser: 0,

      linksLocal: [{ id: null, url: "" }],
      linksOriginal: [],
      linksSaving: false,

      rootUrl: process.env.VUE_APP_FILE_URL,
      urlRules: [
        v => {
          const s = String(v || "").trim();
          if (!s) return true;
          try {
            const u = new URL(s);
            return (u.protocol === "http:" || u.protocol === "https:") || "Только http/https";
          } catch (e) {
            return "Введите корректную ссылку";
          }
        }
      ],

      editStatusName: "",

    };
  },

  computed: {
    users() {
      return this.usersStore.users;
    },
    haveSubordinates() {
      return this.users && this.users.length;
    },

    userAvatar() {
      return this.data && this.hasValue(this.data.avatar);
    },

    interviewOwnerAvatar() {
      return this.interview && this.interview.owner && this.hasValue(this.interview.owner.avatar);
    },

    showActions() {
      return this.isAdmin || (parseInt(this.currentUser) == parseInt(this.interview.owner.id));
      // return parseInt(this.currentUser) == parseInt(this.interview.owner.id);
    },

    editLinks() {
      return this.isAdmin || (parseInt(this.currentUser) == parseInt(this.interview.owner.id));
      // return parseInt(this.currentUser) == parseInt(this.interview.owner.id);
    },
    linksView() {
      const source = this.interview && Array.isArray(this.interview.recordingUrls)
        ? this.interview.recordingUrls
        : this.linksLocal;

      return this.normalizeLinks(source);
    },
    normalizedLinksLocal() {
      return this.normalizeLinksForCompare(this.linksLocal);
    },
    normalizedLinksOriginal() {
      return this.normalizeLinksForCompare(this.linksOriginal);
    },
    isLinksDirty() {
      if (!this.editLinks) return false;

      const hasNew = (this.linksLocal || []).some(it => {
        if (!it) return false;
        if (typeof it === 'string') return it.trim().length > 0;
        return !it.id && String(it.url || '').trim().length > 0;
      });

      return hasNew;
    },

    interviewStatus() {
      return (this.interview && this.interview.status)
        ? this.interview.status
        : 'created';
    },

    actionBtns() {
      return this.interview && this.interview.typeButtons ? this.interview.typeButtons : []
    }
    
  },

  async mounted() {
    this.currentUser = localStorage.getItem("current_user");
    this.roles = globalMethods.getRoles();
    this.isAdmin = globalMethods.isAdmin(this.roles);

    await this.getData();

    const saved = this.interview && Array.isArray(this.interview.recordingUrls) ? this.interview.recordingUrls : [];
    
    const prepared = this.normalizeLinks(saved);
    this.linksLocal = prepared.slice();
    this.linksOriginal = prepared.slice();

    // this.$nextTick(() => {
    //   this.initTaskSticky();
    // });
  },

  // beforeDestroy() {
  //   this.destroyTaskSticky();
  // },

  methods: {
    // загрузка данных
    async getData() {
      this.preloader = true;
      this.tasks = [];
      this.questions = [];
      this.allSkills = [];

      const interviewID = this.$route.query.id;

      // interview
      const result1 = await GlobalRequest.request("/interviews/" + interviewID, "GET");
      this.interview = result1 && result1.data ? result1.data : {};

      if (!this.interview.owner) this.interview.owner = {};
      if (!this.interview.participants) this.interview.participants = [];

      // user
      const intervieweeId = this.interview && this.interview.interviewee && this.interview.interviewee.id
        ? this.interview.interviewee.id
        : null;

      if (intervieweeId) {
        const res = await GlobalRequest.request("/user/" + intervieweeId, "GET");
        this.data = res && res.data ? res.data : {};
      } else {
        this.data = {};
      }

      if (!this.data.heads) this.data.heads = [];
      if (!this.data.subordinates) this.data.subordinates = [];
      if (!this.data.files) this.data.files = [];

      // tree
      await this.getCompetentions();

      this.preloader = false;
    },

    async reloadTree() {
      await this.getCompetentions(true);
      // если был выбран узел — пересоберём списки задач/вопросов
      if (this.currentSelectedNode) {
        const refreshed = this.findNodeById(this.allSkills, this.currentSelectedNode.id);
        if (refreshed) {
          this.currentSelectedNode = refreshed;

          // обновляем списки слева
          this.onSelectNode(refreshed);

          this.$nextTick(() => {
            this.currentCheckCompetency = refreshed.id;
          });
        }
      }
    },

    async getCompetentions(isManualReload) {
      if (isManualReload) this.treeLoading = true;

      const interviewID = this.$route.query.id;

      const result = await GlobalRequest.request("/interviews/" + interviewID + "/tree", "GET");

      // Защита от undefined
      const treeObj = (result && result.data) ? result.data : (result || null);

      const skills = [];
      if (treeObj && treeObj.hardSkills) {
        skills.push({
          title: treeObj.hardSkills.title,
          tag: "HS",
          areas: this.normalizeNodes(treeObj.hardSkills.areas || [], "HS", "", null)
        });
      }
      if (treeObj && treeObj.softSkills) {
        skills.push({
          title: treeObj.softSkills.title,
          tag: "SS",
          areas: this.normalizeNodes(treeObj.softSkills.areas || [], "SS", "", null)
        });
      }

      if (!this.allSkills.length) {
        this.allSkills = skills;
      } else {
        // обновляем существующее дерево
        this.mergeSkills(this.allSkills, skills);
      }

      if (!this.currentSelectedNode && skills.length) {
        const firstSkill = skills[0];
        if (firstSkill.areas && firstSkill.areas.length) {
          const firstArea = firstSkill.areas[0];
          this.onSelectNode(firstArea);
        }
      }

      if (isManualReload) this.treeLoading = false;
    },

    mergeSkills(oldSkills, newSkills) {
      for (let i = 0; i < oldSkills.length; i++) {
        const oldSkill = oldSkills[i];
        const newSkill = newSkills[i];

        if (!newSkill) continue;

        this.mergeNodes(oldSkill.areas, newSkill.areas);
      }
    },

    mergeNodes(oldNodes, newNodes) {
      for (let i = 0; i < oldNodes.length; i++) {
        const oldNode = oldNodes[i];
        const newNode = newNodes.find(n => n.id === oldNode.id);

        if (!newNode) continue;

        // обновляем ТОЛЬКО данные
        // oldNode.score = newNode.score;
        // oldNode.viewerRights = newNode.viewerRights;
        // oldNode.targetRights = newNode.targetRights;

        this.$set(oldNode, 'score', newNode.score);
        this.$set(oldNode, 'viewerRights', newNode.viewerRights);
        this.$set(oldNode, 'targetRights', newNode.targetRights);

        if (oldNode.children && oldNode.children.length) {
          this.mergeNodes(oldNode.children, newNode.children || []);
        }
      }
    },

    // вычисляем parentId + breadcrumbParents
    normalizeNodes(list, tag, parentBreadcrumb, parentId) {
      const res = [];

      for (let i = 0; i < list.length; i++) {
        const n = list[i];

        const title = this.safeStr(n.title);
        const breadcrumbFull = parentBreadcrumb
          ? (parentBreadcrumb + " / " + title)
          : (tag + " / " + title);

        // breadcrumbParents — строка родителей
        const breadcrumbParents = parentBreadcrumb
          ? (parentBreadcrumb + " / ")
          : (tag + " / ");

        const node = {
          id: n.id,
          type: n.type,
          title: title,
          description: n.description || "",
          gitUrl: n.gitUrl || "",
          answerText: n.answerText || "",
          path: n.path || null,
          key: n.key || null,
          files: n.files || [],
          weight: n.weight,
          score: (typeof n.score === "undefined") ? null : n.score,
          viewerRights: n.viewerRights || {},
          targetRights: n.targetRights || {},
          parentId: parentId,
          tag: tag,
          breadcrumbFull: breadcrumbFull,
          breadcrumbParents: breadcrumbParents,
          children: []
        };

        const children = (n.children && n.children.length) ? n.children : [];
        node.children = this.normalizeNodes(children, tag, breadcrumbFull, node.id);

        res.push(node);
      }

      return res;
    },

    // выбор узла (справа) -> задачи/вопросы (слева)
    onSelectNode(node) {
      if (!node || !node.id) return;

      this.currentCheckCompetency = node.id;
      this.currentSelectedNode = node;

      const collected = this.collectTasksQuestions(node, node.breadcrumbFull);

      let newTasks = [];
      let newQuestions = [];

      if (collected.tasks.length || collected.questions.length) {
        newTasks = collected.tasks;
        newQuestions = collected.questions;
      }

      this.tasks = newTasks;
      this.questions = newQuestions;

      if (this.questions.length > 0) this.leftTab = 'questions';
      else if (this.tasks.length > 0) this.leftTab = 'tasks';

    },

    collectTasksQuestions(node, breadcrumbBase) {
      let tasks = [];
      let questions = [];

      if (!node || !node.children) {
        return { tasks, questions };
      }

      for (let i = 0; i < node.children.length; i++) {
        const child = node.children[i];

        const parentBreadcrumb = breadcrumbBase + ' / ';

        if (child.type === 'task') {
          tasks.push(this.asLeftItem(child, parentBreadcrumb));
        } 
        else if (child.type === 'question') {
          questions.push(this.asLeftItem(child, parentBreadcrumb));
        } 
        else {
          // уходим глубже
          const res = this.collectTasksQuestions(child, child.breadcrumbFull);
          tasks = tasks.concat(res.tasks);
          questions = questions.concat(res.questions);
        }
      }

      return { tasks, questions };
    },

    asLeftItem(node, breadcrumbParents) {
      // item для списков слева: breadcrumb должен показывать родителей
      return {
        id: node.id,
        type: node.type,
        title: node.title,
        description: node.description || "",
        answerText: node.answerText || "",
        gitUrl: node.gitUrl || "",
        files: node.files || [],
        score: node.score,
        tag: node.tag,
        viewerRights: node.viewerRights || {},
        breadcrumb: breadcrumbParents // цепочка родителей
      };
    },

    // Оценка
    selectMark(val) {
      this.mark = val;
    },

    onRequestMark(payload) {
      if (!payload || !payload.node) return;

      const node = payload.node;

      // если узел не task/question и у него есть дети — подтверждение
      if (payload.mode === "confirm") {
        this.currentParentElem = node;
        this.confirmForm = true;
        return;
      }

      // иначе сразу ставим
      this.addMark(node, false);
    },

    async addMark(node, isBulkConfirmed, type) {
      // пользователь подтвердил оценку родителя с детьми
      this.confirmForm = false;

      if (!node || !node.id) return;

      this.markFlag = true;
      this.clickMarkElement = node.id;

      var body = {
        userId: this.data.id,
        elementId: node.id,
        score: parseFloat(this.mark)
      };

      const res = await GlobalRequest.request(
        "/scores/assign",
        "POST",
        body
      );

      if(res && res.serviceAnswer && res.serviceAnswer.error) {
        this.notifyVue('bottom', 'right', 4, "Во время оценки элемента '" + node.title + "' произошла ошибка");
        this.markFlag = false;
        this.clickMarkElement = 0;
        return;
      }

      // обновляем дерево и списки
      await this.getCompetentions();

      if (this.currentSelectedNode) {
        // найти обновлённый узел по id в новом дереве
        const refreshed = this.findNodeById(this.allSkills, this.currentSelectedNode.id);
        if (refreshed) this.onSelectNode(refreshed);
      }

      this.markFlag = false;
      this.clickMarkElement = 0;

      if(type) {
        this.leftTab = type;
      }
    },

    findNodeById(skills, id) {
      if (!skills || !skills.length) return null;

      for (let s = 0; s < skills.length; s++) {
        const areas = skills[s].areas || [];
        const found = this.findInNodes(areas, id);
        if (found) return found;
      }
      return null;
    },

    findInNodes(nodes, id) {
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].id === id) return nodes[i];
        if (nodes[i].children && nodes[i].children.length) {
          const f = this.findInNodes(nodes[i].children, id);
          if (f) return f;
        }
      }
      return null;
    },

    showMarksFooter(item) {
      // только если можно ставить оценку
      if (!item) return false;
      if (!item.viewerRights) return false;
      return !!item.viewerRights.canPostScore && this.interview.status == 'in_progress';
    },

    closeForm() {
      this.confirmForm = false;
      this.currentParentElem = null;
    },

    async updateInterview(statusName) {
      this.editStatusName = statusName;
      this.loadstatusInterview = true;

      const interviewID = this.$route.query.id;

      const resStatus = await GlobalRequest.request("/interviews/status/" + interviewID + "/" + statusName, "PUT");

      if(resStatus && resStatus.success) {
        if(statusName == "offer_sent") {
          this.notifyVue('bottom', 'right', 2, "Оффер успешно отправлен")
        }

        this.interview = resStatus && resStatus.data ? resStatus.data : this.interview;
        if (!this.interview.owner) this.interview.owner = {};
        if (!this.interview.participants) this.interview.participants = [];

        this.editStatusName = "";
        this.loadstatusInterview = false;
      } else {
        if(statusName == "offer_sent") {
          this.notifyVue('bottom', 'right', 4, "При отправке оффера произошла ошибка")
        } else {
          this.notifyVue('bottom', 'right', 4, "При смене статуса произошла ошибка")
        }

        this.editStatusName = "";
        this.loadstatusInterview = false;
      }
      
    },

    goBack() {
      this.$router.push({
        name: this.$route.query.back,
        query: this.$route.query
      });
    },

    safeStr(v) {
      return (v === undefined || v === null) ? "" : String(v);
    },

    hasValue(v) {
      return !(v === undefined || v === null || v === "");
    },

    getStyleAvatar(path) {
      return 'background-image: url("' + path + '"); height: 100%; width: 100%; ';
    },

    getNumber(num) {
      return globalMethods.getNumber(num);
    },

    getStatus(status) {
      const map = globalMethods.interviewStatusLabels();
      return map[status] || "";
    },

    getStyleStatus(status) {
      const map = globalMethods.interviewStatusClass(); 
      return map[status] || "";
    },

    getStringDate(str) {
      if (str !== undefined && str !== null && String(str).length > 0) {
        const arr = String(str).split("-");
        if (arr.length === 3) return arr[2] + "." + arr[1] + "." + arr[0];
      }
      return "";
    },

    getFileIconClass(ext) {
      const e = (ext || "").toLowerCase();
      if (e === "doc" || e === "docx") return "fa fa-file-word-o";
      if (e === "xls" || e === "xlsx") return "fa fa-file-excel-o";
      if (e === "png" || e === "jpg" || e === "jpeg") return "fa fa-file-image-o";
      if (e === "pdf") return "fa fa-file-pdf-o";
      if (e === "txt") return "fa fa-file-text-o";
      return "fa fa-file-o";
    },

    formatDate(value) {
      if (!value) return "";

      const [date, time] = value.split('T');
      const [year, month, day] = date.split('-');

      return `${day}.${month}.${year} ${time}`;
    },

    formatDateChange(str) {
      if (!str) return "";

      const parts = String(str).trim().split(" ");
      const datePart = parts[0];
      const timePart = parts[1] || "";

      const d = datePart.split("-");
      if (d.length !== 3) return str;

      const year = d[0];
      const month = d[1];
      const day = d[2];

      const time = timePart ? timePart.slice(0, 5) : "";

      return `${day}.${month}.${year}${time ? " " + time : ""}`;
    },

    notifyVue(verticalAlign, horizontalAlign, color, text) {
      this.$notify({
        component: NotificationTemplate,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: this.type[color],
        message: text,
      });
    },

    initTaskSticky() {
      var el = this.$refs.taskBlock;
      var anchor = this.$refs.taskAnchor;
      if (!el || !anchor) return;

      var col = el.closest('.col-md-5');
      if (!col) col = el.parentNode;

      this.taskStickyEl = el;
      this.taskStickyAnchor = anchor;
      this.taskStickyCol = col;

      this.onTaskStickyScroll = this.handleTaskStickyScroll.bind(this);
      this.onTaskStickyResize = this.handleTaskStickyResize.bind(this);

      window.addEventListener('scroll', this.onTaskStickyScroll, { passive: true });
      window.addEventListener('resize', this.onTaskStickyResize);

      this.handleTaskStickyResize();
      this.handleTaskStickyScroll();
    },

    destroyTaskSticky() {
      if (this.onTaskStickyScroll) window.removeEventListener('scroll', this.onTaskStickyScroll);
      if (this.onTaskStickyResize) window.removeEventListener('resize', this.onTaskStickyResize);
      this.onTaskStickyScroll = null;
      this.onTaskStickyResize = null;
      this.taskStickyEl = null;
      this.taskStickyCol = null;
    },

    handleTaskStickyResize() {
      var el = this.taskStickyEl;
      var col = this.taskStickyCol;
      var anchor = this.taskStickyAnchor;
      if (!el || !col || !anchor) return;

      var colRect = col.getBoundingClientRect();

      var padL = this.getElPx(col, "paddingLeft");
      var padR = this.getElPx(col, "paddingRight");

      var contentWidth = colRect.width - padL - padR;
      if (contentWidth < 0) contentWidth = 0;

      // Порог sticky считаем по якорю (он всегда в потоке)
      var aRect = anchor.getBoundingClientRect();
      var docTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.taskStickyTop = aRect.top + docTop;

      // Обновляем width всегда
      var nextStyle = Object.assign({}, this.taskSticky.style, {
        width: contentWidth + "px"
      });

      // Если fixed — обновим left тоже (иначе оставим пустым, чтобы в потоке не мешал)
      if (this.taskSticky.isFixed) {
        nextStyle.left = (colRect.left + padL) + "px";
      }

      this.taskSticky.style = nextStyle;

      // После resize сразу прогоняем scroll-логику,
      // чтобы правильно включить/выключить fixed на новом layout
      this.handleTaskStickyScroll();
    },

    handleTaskStickyScroll() {
      var el = this.taskStickyEl;
      var col = this.taskStickyCol;
      if (!el || !col) return;

      var topOffset = 20;
      var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (scrollY + topOffset < this.taskStickyTop) {
        this.taskSticky.isFixed = false;
        this.taskSticky.style = Object.assign({}, this.taskSticky.style, {
          top: "",
          left: ""
        });
        return;
      }

      var colRect = col.getBoundingClientRect();
      var padL = this.getElPx(col, "paddingLeft");
      var padR = this.getElPx(col, "paddingRight");

      var contentWidth = colRect.width - padL - padR;
      if (contentWidth < 0) contentWidth = 0;

      this.taskSticky.isFixed = true;
      this.taskSticky.style = Object.assign({}, this.taskSticky.style, {
        top: topOffset + "px",
        left: (colRect.left + padL) + "px",
        width: contentWidth + "px"
      });
    },

    // переключение вкладок
    setLeftTab(tab) {
      this.leftTab = tab;

      // после переключения не оставаться в середине скролла списка
      this.$nextTick(() => {
        var el = this.$refs.taskBlock;
        if (!el) return;

        // скролл на оба контейнера
        var containers = el.querySelectorAll('.block-task-question__container');
        if (containers && containers.length) {
          for (var i = 0; i < containers.length; i++) {
            containers[i].scrollTop = 0;
          }
        }
      });
    },

    getElPx(el, prop) {
      var cs = window.getComputedStyle(el);
      var v = cs && cs[prop] ? cs[prop] : "0";
      var n = parseFloat(v);
      return isNaN(n) ? 0 : n;
    },

    goToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },

    showToTopBtn() {
      var el = this.$refs.taskBlock;
      if (!el) return false;

      var h = el.getBoundingClientRect().height;

      return h > 500;
    },

    addLinkField() {
      if (this.linksLocal.length >= 10) return;
      this.linksLocal.push({ id: null, url: "" });
    },

    async removeLinkField(index) {
      const item = this.linksLocal[index];

      // если есть id, то удаляем
      if (item && item.id) {
        const interviewID = this.$route.query.id;
        this.linksSaving = true;
        try {
          const res = await GlobalRequest.request(
            `/interviews/delete-recordings/${item.id}`,
            "DELETE"
          );

          if(res.success) {
            // получить список
            const refreshed = await GlobalRequest.request(`/interviews/${interviewID}`, "GET");
            this.interview = refreshed && refreshed.data ? refreshed.data : this.interview;

            const saved = this.interview && Array.isArray(this.interview.recordingUrls)
              ? this.interview.recordingUrls
              : [];

            const prepared = this.normalizeLinks(saved);
            this.linksLocal = prepared.slice();
            this.linksOriginal = prepared.slice();

            // this.notifyVue('bottom', 'right', 2, "Ссылка удалена");
          } else {
            this.notifyVue('bottom', 'right', 4, "Не удалось удалить ссылку");
          }
        } catch (e) {
          console.error("Ошибка удаления ссылки:", e);
          this.notifyVue('bottom', 'right', 4, "Не удалось удалить ссылку");
        } finally {
          this.linksSaving = false;
        }
        return;
      }

      // если без id, удаляем локально
      this.linksLocal.splice(index, 1);
      if (this.linksLocal.length === 0) this.linksLocal = [{ id: null, url: "" }];
    },

    // сохранять в data перед отправкой на сервер
    getLinksForSave() {
      return this.linksLocal
        .map(s => String(s || '').trim())
        .filter(Boolean)
        .slice(0, 10);
    },

    normalizeLinks(arr) {
      const list = Array.isArray(arr) ? arr : [];

      const cleaned = list
        .map(it => {
          if (typeof it === "string") return { id: null, url: it };
          return { id: it && it.id ? it.id : null, url: it && it.url ? String(it.url) : "" };
        })
        .map(it => ({ id: it.id, url: String(it.url || "").trim() }))
        .filter(it => it.url.length > 0)
        .slice(0, 10);

      return cleaned.length ? cleaned : [{ id: null, url: "" }];
    },

    async saveLinks() {
      if (!this.editLinks) return;

      if (this.$refs.linksForm && !this.$refs.linksForm.validate()) {
        return;
      }

      const interviewID = this.$route.query.id;

      const local = this.normalizeLinks(this.linksLocal);
      const original = this.normalizeLinks(this.linksOriginal);

      // новые без id
      const added = local.filter(it => !it.id && it.url);
      if (!added.length) return;

      this.linksSaving = true;
      try {
        const res = await GlobalRequest.request(
          `/interviews/add-recordings/${interviewID}`,
          "POST",
          { recordingUrls: added.map(it => it.url) }
        );

        if(res.success) {
          const refreshed = await GlobalRequest.request(`/interviews/${interviewID}`, "GET");
          this.interview = refreshed && refreshed.data ? refreshed.data : this.interview;

          const saved = this.interview && Array.isArray(this.interview.recordingUrls)
            ? this.interview.recordingUrls
            : [];

          const prepared = this.normalizeLinks(saved);
          this.linksLocal = prepared.slice();
          this.linksOriginal = prepared.slice();

          // this.notifyVue('bottom', 'right', 2, "Ссылки на запись сохранены");
        } else {
          console.error("Ошибка сохранения ссылок:", e);
          this.notifyVue('bottom', 'right', 4, "Не удалось сохранить ссылки");
        }
      } catch (e) {
        console.error("Ошибка сохранения ссылок:", e);
        this.notifyVue('bottom', 'right', 4, "Не удалось сохранить ссылки");
      } finally {
        this.linksSaving = false;
      }
    },

    goToProfile(id) {
      this.$router.push({
        name: 'profile',
        query: {
          userID: id,
          back: this.$route.name
        }
      });
    },

    getFileName(file) {
      return (file && (file.realFileName || file.file_name || file.title || file.name)) ? (file.realFileName || file.file_name || file.title || file.name) : "file";
    },
    getFileHref(file) {
      return (file && (file.filePath || file.file_link || file.file_path)) ? (file.filePath || file.file_link || file.file_path) : "#";
    },
    fileIcon(ext) {
      const map = {
        doc: "fa fa-file-word-o",
        docx: "fa fa-file-word-o",
        xls: "fa fa-file-excel-o",
        xlsx: "fa fa-file-excel-o",
        jpg: "fa fa-file-image-o",
        jpeg: "fa fa-file-image-o",
        png: "fa fa-file-image-o",
        pdf: "fa fa-file-pdf-o",
      };
      return map[ext] || "fa fa-file-o";
    },
    getFileExt(file) {
      var name = this.getFileName(file);
      var parts = name.split(".");
      return parts.length > 1 ? parts.pop().toLowerCase() : "";
    },

    answerFiles(item) {
      var files = item.files ? item.files : [];
      return files.filter(function(f) {
        return !(f && f.file_attachment_type === "condition");
      });
    },

    conditionFiles(item) {
      var files = item.files ? item.files : [];
      return files.filter(function(f) {
        return (f && f.file_attachment_type === "condition");
      });
    },

    normalizeLinksForCompare(arr) {
      const list = Array.isArray(arr) ? arr : [];
      return list
        .map(it => {
          if (typeof it === "string") return { id: null, url: it };
          return { id: it && it.id ? it.id : null, url: it && it.url ? String(it.url) : "" };
        })
        .map(it => ({ id: it.id, url: String(it.url || "").trim() }))
        .slice(0, 10);
    },

    showLoader(keyStatus) {
      return this.loadstatusInterview && this.editStatusName == keyStatus;
    },

    copyLink(url) {
      navigator.clipboard.writeText(url)
        .then(() => {
          this.notifyVue('bottom', 'right', 2, "Ссылка скопирована");
        });
    },

    getType(interview) {
      if(interview && interview.type && interview.type.name) {
        return interview.type.name
      } else {
        return "Не определено"
      }
    },

  }
};
</script>

<style>
.mark-circle {
  font-size: 20px;
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-right: 10px;
  z-index: 999999;
}
.custom-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.bg-none {
  background: none !important;
  padding: 6px 18px 16px !important;
  margin-top: -10px !important;
}
.interviewD .container-interview-title {
  padding-left: 20px;
  padding-top: 7px;
}
/* .custom-acc .task-interview-container {
  margin: 0 -24px;
} */
.custom-acc h3 {
  font-family: 'Montserrat', sans-serif;
  text-transform: uppercase;
  font-size: 14px !important;
  font-weight: 600;
}
.upp-h3 {
  font-family: 'Montserrat', sans-serif;
  font-size: 14px !important;
  font-weight: 500;
  padding-top: 13px;
}
.breadcumbs-interview {
  font-size: 11px;
  color: #7c7c7c;
  padding-bottom: 5px;
}
/* .interviewD h3 {
  transition: 0.3s;
  cursor: pointer;
} */
/* .interviewD h3:hover {
  text-decoration: underline;
} */
.v-expansion-panel-header:before {
  background-color: none !important;
  border-radius: 0;
}
.v-expansion-panel-header:focus {
  background-color: #fff !important;
}
.sectionSkillInt:last-child {
  margin-top: 20px;
}
h3.header-title {
  margin: 0 !important;
}
.v-expansion-panel-content__wrap {
    padding: 0 24px 5px !important;
}
.block-task-question .v-expansion-panel-content__wrap {
  max-height: 450px;
  overflow: auto;
}
.block-task-question h3 {
  margin-bottom: 0;
}
.block-task-question__container {
  max-height: calc(100vh - 203px);
  overflow: auto;
}
.block-task-question__container::-webkit-scrollbar {
  border-radius: 100px;
  background: #e3e3e3;
  height: 5px;
  width: 5px;
  cursor: pointer;
}
.block-task-question__container::-webkit-scrollbar-thumb {
  background: #cacaca;
  border-radius: 100px;
  cursor: pointer;
}
.v-application .mt-2:first-child {
  margin-top: 0 !important;
}
.task-fixed {
  position: fixed;
  top: 20px;
  z-index: 50;
}

.block-task-question__title-btns {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}
.interview-card-custom {
  margin-bottom: 20px;
}

.block-task-question__tab {
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;

  font-family: 'Montserrat', sans-serif;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;

  position: relative;
  color: #111;
}

.block-task-question__tab.active::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -6px;
  height: 2px;
  background: currentColor;
}

.block-task-question__count{
  margin-left: 8px;
  font-size: 12px;
  opacity: 0.7;
}

.task-fixed { box-sizing: border-box; }

.mark-circle {
    z-index: 0;
}
.squareBtn {
  padding: 0 !important;
  min-width: 36px !important;
  width: 36px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.squareBtn i {
  margin: 0 !important;
}

.links-editor .link-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  justify-content: space-between;
}

.links-editor .link-input {
  flex: 1;
}

.links-editor .link-btn {
  margin-top: 4px;
}

.links-hint {
  font-size: 12px;
  opacity: 0.7;
  margin-top: 6px;
}
.link-view-row {
  margin-bottom: 6px;
}

.links-actions .text-center {
  display: flex;
  gap: 15px;
  justify-content: center;
}
.p-link {
  cursor: pointer;
  transition: 0.3s;
}
.p-link:hover {
  text-decoration: underline;
}
.interview-link {
  width: calc(100% - 52px);
}
.links-editor .action-link {
    margin-top: -5px;
}
.custom-flex-btns {
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}
.status-btns .primary-btn {
  min-width: 194px !important;
}
</style>
